import {
  AREA_UNITS,
  MEASUREMENT_SYSTEMS,
  UNIT_SYMBOLS,
} from '@src/constants/measureUnits.ts';
import {useAppSelector} from '@src/hooks/redux.ts';
import formatArea from '@src/utils/formatArea.ts';

type AreaIndicatorProps = {
  // The value in square meters
  squareMeters: number;

  // The unit to display the area in. This should generally be left
  // blank so that it uses the user's preference
  unit?: string;
};

const AreaIndicator = ({squareMeters, unit = ''}: AreaIndicatorProps) => {
  const settingsUnit = useAppSelector(state =>
    state.settings.measurementSystem === MEASUREMENT_SYSTEMS.metric
      ? state.settings.areaUnitsMetric
      : state.settings.areaUnitsUSC,
  );

  const displayUnit =
    unit || settingsUnit || AREA_UNITS[MEASUREMENT_SYSTEMS.metric].km2;

  const formattedArea = formatArea(squareMeters, displayUnit);

  return `${formattedArea} ${UNIT_SYMBOLS[displayUnit]}`;
};

export default AreaIndicator;
